import { CMSPopupDialog } from "./CMSPopupDialog";
import { StrapiModel } from "./StrapiModel";

export class CMSCampaign extends StrapiModel {
    slug: string;
    data: any;

    // Layout
    startDate?: Date;
    endDate?: Date;
    redirectWhenEventEnd?: string;
    shouldShowHeader: boolean;
    shouldShowFooter: boolean;
    password?: string;
    requirePassword: boolean;
    // SEO
    seoTitle?: string;
    seoDescription?: string;
    seoImageUrl?: string;
    seoShouldSkipPostfix: boolean;
    noIndex: boolean;
    
    constructor(obj?: Partial<CMSPopupDialog>) {
        super();
        Object.assign(this, obj);
    }
}